$(window).on('load scroll', function(){

  var elem1 = $('.boxInner');
  var elem2 = $('.appear');

  elem1.each(function () {

    var isPlay = 'isPlay';
    var elemOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();

    if(scrollPos > elemOffset - wh + (wh / 4)){
      $(this).addClass(isPlay);
    }
  });
  
  elem2.each(function () {

    var isAppear = 'isAppear';
    var elemOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();

    if(scrollPos > elemOffset - wh){
      $(this).addClass(isAppear);
    }
  });
});